import { VendorStockInventoryPage } from "@/features/vendor-app/pages/VendorStockInventoryPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/stock/$productID/inventory")({
	component: VendorStockInventoryPage,
});
